import { type DocumentNode } from "@apollo/client";
import { z } from "zod";
import { GetDebuggingDocument, GetGameDocument, GetLandingPageMappingsDocument, GetPreloaderTippsDocument, GetTooltipsDocument } from "../graphql/generated/graphql";
import { getQueryRootFieldName } from "../graphql/queryMeta";

/** Raw endpoint definition — the query document is the single source of truth. */
export interface StrapiEndpointInput {
    /** Generated GraphQL query document */
    query: DocumentNode;
    /** Optional Zod schema for validation */
    schema?: z.ZodSchema;
    /** Optional variables for the query */
    variables?: Record<string, unknown>;
}

export interface StrapiEndpointConfig extends StrapiEndpointInput {
    /** Cache key, automatically derived from the query's root field name */
    key: string;
}

/**
 * Configure which Strapi queries to fetch during prebuild.
 * Add a new entry here to make a query available throughout the app — the
 * cache key is derived from the query itself, so the name appears nowhere else.
 */
const strapiEndpointInputs: StrapiEndpointInput[] = [
    { query: GetDebuggingDocument },
    { query: GetPreloaderTippsDocument },
    { query: GetLandingPageMappingsDocument },
    { query: GetGameDocument },
    { query: GetTooltipsDocument },
];

export const strapiEndpoints: StrapiEndpointConfig[] = strapiEndpointInputs.map(
    (endpoint) => ({
        ...endpoint,
        key: getQueryRootFieldName(endpoint.query),
    }),
);
